import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
export const buildCDNImageUrl = (
  image: string,
  size: PRODUCT_IMAGE_SIZE = PRODUCT_IMAGE_SIZE.FULL,
) => {
  return decodeURIComponent(
    process.env.NEXT_PUBLIC_PIK_CDN_ENDPOINT + '/' + image.replace('.webp', `-${size}.webp`),
  );
};
export const buildSectionImageUrl = (
  image: string,
  size: PRODUCT_IMAGE_SIZE = PRODUCT_IMAGE_SIZE.FULL,
) => {
  return decodeURIComponent(
    process.env.NEXT_PUBLIC_PIK_CDN_ENDPOINT + '/' + image.replace('.webp', `-${size}.webp`),
  );
};
export enum PRODUCT_IMAGE_SIZE {
  SMALL = 'SxS',
  MEDIUM = 'MxM',
  LARGE = 'LxL',
  FULL = 'LxL',
}
